// UniswapV2 Router ABI (for V2 DEXes)
export const UNISWAP_V2_ROUTER_ABI = [
  "function getAmountsOut(uint amountIn, address[] memory path) external view returns (uint[] memory amounts)",
  "function swapExactTokensForTokens(uint amountIn, uint amountOutMin, address[] calldata path, address to, uint deadline) external returns (uint[] memory amounts)",
  "function swapExactETHForTokens(uint amountOutMin, address[] calldata path, address to, uint deadline) external payable returns (uint[] memory amounts)",
  "function swapExactTokensForETH(uint amountIn, uint amountOutMin, address[] calldata path, address to, uint deadline) external returns (uint[] memory amounts)",
  "function swapTokensForExactTokens(uint amountOut, uint amountInMax, address[] calldata path, address to, uint deadline) external returns (uint[] memory amounts)",
  "function swapETHForExactTokens(uint amountOut, address[] calldata path, address to, uint deadline) external payable returns (uint[] memory amounts)",
  "function swapTokensForExactETH(uint amountOut, uint amountInMax, address[] calldata path, address to, uint deadline) external returns (uint[] memory amounts)",
  "function factory() external pure returns (address)",
  "function WETH() external pure returns (address)",
];

// UniswapV2 Factory ABI
export const UNISWAP_V2_FACTORY_ABI = [
  "function getPair(address tokenA, address tokenB) external view returns (address pair)",
  "function allPairs(uint) external view returns (address pair)",
  "function allPairsLength() external view returns (uint)",
  "function feeTo() external view returns (address)",
  "function feeToSetter() external view returns (address)",
  "function createPair(address tokenA, address tokenB) external returns (address pair)",
];

// UniswapV2 Pair ABI
export const UNISWAP_V2_PAIR_ABI = [
  "function getReserves() external view returns (uint112 reserve0, uint112 reserve1, uint32 blockTimestampLast)",
  "function token0() external view returns (address)",
  "function token1() external view returns (address)",
];

// UniswapV3 Quoter V2 ABI
export const UNISWAP_V3_QUOTER_ABI = [
  "function quoteExactInputSingle((address tokenIn, address tokenOut, uint256 amountIn, uint24 fee, uint160 sqrtPriceLimitX96)) external returns (uint256 amountOut, uint160 sqrtPriceX96After, uint32 initializedTicksCrossed, uint256 gasEstimate)",
  "function quoteExactInput(bytes memory path, uint256 amountIn) external returns (uint256 amountOut, uint160[] memory sqrtPriceX96AfterList, uint32[] memory initializedTicksCrossedList, uint256 gasEstimate)",
  "function quoteExactOutputSingle((address tokenIn, address tokenOut, uint256 amount, uint24 fee, uint160 sqrtPriceLimitX96)) external returns (uint256 amountIn, uint160 sqrtPriceX96After, uint32 initializedTicksCrossed, uint256 gasEstimate)",
  "function quoteExactOutput(bytes memory path, uint256 amountOut) external returns (uint256 amountIn, uint160[] memory sqrtPriceX96AfterList, uint32[] memory initializedTicksCrossedList, uint256 gasEstimate)",
];

// Simplified QuoterV2 ABI for static calls
export const QUOTER_V2_STATIC_ABI = [
  "function quoteExactInputSingle(address tokenIn, address tokenOut, uint24 fee, uint256 amountIn, uint160 sqrtPriceLimitX96) external returns (uint256 amountOut)",
  "function quoteExactInput(bytes memory path, uint256 amountIn) external returns (uint256 amountOut)",
];

// UniswapV3 SwapRouter ABI
export const UNISWAP_V3_ROUTER_ABI = [
  "function exactInputSingle((address tokenIn, address tokenOut, uint24 fee, address recipient, uint256 amountIn, uint256 amountOutMinimum, uint160 sqrtPriceLimitX96)) external payable returns (uint256 amountOut)",
  "function exactInput((bytes path, address recipient, uint256 amountIn, uint256 amountOutMinimum)) external payable returns (uint256 amountOut)",
  "function exactOutputSingle((address tokenIn, address tokenOut, uint24 fee, address recipient, uint256 amountOut, uint256 amountInMaximum, uint160 sqrtPriceLimitX96)) external payable returns (uint256 amountIn)",
  "function exactOutput((bytes path, address recipient, uint256 amountOut, uint256 amountInMaximum)) external payable returns (uint256 amountIn)",
  "function multicall(bytes[] calldata data) external payable returns (bytes[] memory results)",
  "function refundETH() external payable",
  "function sweepToken(address token, uint256 amountMinimum, address recipient) external payable",
  "function unwrapWETH9(uint256 amountMinimum, address recipient) external payable",
  "function wrapETH(uint256 value) external payable",
];

// UniswapV3 Factory ABI
export const UNISWAP_V3_FACTORY_ABI = [
  "function getPool(address tokenA, address tokenB, uint24 fee) external view returns (address pool)",
  "function owner() external view returns (address)",
  "function feeAmountTickSpacing(uint24 fee) external view returns (int24)",
  "function createPool(address tokenA, address tokenB, uint24 fee) external returns (address pool)",
];

// UniswapV3 Pool ABI
export const UNISWAP_V3_POOL_ABI = [
  "function token0() external view returns (address)",
  "function token1() external view returns (address)",
  "function fee() external view returns (uint24)",
  "function tickSpacing() external view returns (int24)",
  "function liquidity() external view returns (uint128)",
  "function slot0() external view returns (uint160 sqrtPriceX96, int24 tick, uint16 observationIndex, uint16 observationCardinality, uint16 observationCardinalityNext, uint8 feeProtocol, bool unlocked)",
];

// Vault ABI (reuse from V1)
export const VAULT_ABI = [
  "function receiveFee(address token, uint256 amount) external payable",
  "function withdrawToken(address token, uint256 amount) external",
  "function withdrawNative(uint256 amount) external",
  "function getTokenBalance(address token) external view returns (uint256)",
  "function owner() external view returns (address)",
  "function swapperContract() external view returns (address)",
  "function setSwapperContract(address _swapper) external",
  "function transferOwnership(address newOwner) external",
  "function pause() external",
  "function unpause() external",
  "function paused() external view returns (bool)",
  "event FeeReceived(address indexed token, uint256 amount, address indexed from)",
  "event TokensWithdrawn(address indexed token, uint256 amount, address indexed to)",
  "event OwnershipTransferred(address indexed previousOwner, address indexed newOwner)",
  "event SwapperContractUpdated(address indexed oldSwapper, address indexed newSwapper)",
  "event Paused(address account)",
  "event Unpaused(address account)"
];

// SwapperV2 Contract ABI - handles multi-DEX swaps with fee collection
export const SWAPPER_V2_ABI = [
  "function swapV2ExactTokensForTokens(address router, uint256 amountIn, uint256 amountOutMin, address[] path, uint256 deadline) external returns (uint256)",
  "function swapV2ExactETHForTokens(address router, uint256 amountOutMin, address[] path, uint256 deadline) external payable returns (uint256)",
  "function swapV2ExactTokensForETH(address router, uint256 amountIn, uint256 amountOutMin, address[] path, uint256 deadline) external returns (uint256)",
  "function swapV2CrossDex(address router1, address router2, uint256 amountIn, uint256 amountOutMin1, uint256 amountOutMin2, address[] path1, address[] path2, uint256 deadline) external returns (uint256)",
  "function swapV3ExactInput(address router, bytes path, uint256 amountIn, uint256 amountOutMinimum, uint256 deadline, bool isNativeOut) external payable returns (uint256)",
  "function FEE_PERCENTAGE() external view returns (uint256)",
  "function BASIS_POINTS() external view returns (uint256)",
  "function WFTM() external view returns (address)",
  "function vault() external view returns (address)",
  "function owner() external view returns (address)",
  "function setVault(address _vault) external",
  "function emergencyWithdraw(address token, uint256 amount) external",
  "event SwapExecuted(address indexed user, address indexed tokenIn, address indexed tokenOut, uint256 amountIn, uint256 amountOut, uint256 feeAmount)",
  "event VaultUpdated(address indexed oldVault, address indexed newVault)"
];

// ERC20 Token ABI
export const ERC20_ABI = [
  "function name() external view returns (string)",
  "function symbol() external view returns (string)",
  "function decimals() external view returns (uint8)",
  "function totalSupply() external view returns (uint256)",
  "function balanceOf(address owner) external view returns (uint256)",
  "function allowance(address owner, address spender) external view returns (uint256)",
  "function approve(address spender, uint256 amount) external returns (bool)",
  "function transfer(address to, uint256 amount) external returns (bool)",
  "function transferFrom(address from, address to, uint256 amount) external returns (bool)",
  "event Transfer(address indexed from, address indexed to, uint256 value)",
  "event Approval(address indexed owner, address indexed spender, uint256 value)"
];

// WFTM (Wrapped FTM) ABI
export const WFTM_ABI = [
  ...ERC20_ABI,
  "function deposit() external payable",
  "function withdraw(uint256 amount) external",
];

// Helper function to encode V3 path for multi-hop swaps
export const encodeV3Path = (path, fees) => {
  const FEE_SIZE = 3;
  
  if (path.length !== fees.length + 1) {
    throw new Error('Path and fees length mismatch');
  }
  
  let encoded = '0x';
  for (let i = 0; i < fees.length; i++) {
    // Encode token address (20 bytes)
    encoded += path[i].slice(2);
    // Encode fee (3 bytes)
    const feeHex = fees[i].toString(16).padStart(FEE_SIZE * 2, '0');
    encoded += feeHex;
  }
  // Encode final token
  encoded += path[path.length - 1].slice(2);
  
  return encoded;
};

// Helper function to decode V3 path
export const decodeV3Path = (path) => {
  const ADDRESS_SIZE = 20;
  const FEE_SIZE = 3;
  const STEP_SIZE = ADDRESS_SIZE + FEE_SIZE;
  
  const pathBuffer = Buffer.from(path.slice(2), 'hex');
  
  const tokens = [];
  const fees = [];
  
  let offset = 0;
  tokens.push('0x' + pathBuffer.slice(offset, offset + ADDRESS_SIZE).toString('hex'));
  offset += ADDRESS_SIZE;
  
  while (offset < pathBuffer.length) {
    fees.push(parseInt(pathBuffer.slice(offset, offset + FEE_SIZE).toString('hex'), 16));
    offset += FEE_SIZE;
    
    if (offset < pathBuffer.length) {
      tokens.push('0x' + pathBuffer.slice(offset, offset + ADDRESS_SIZE).toString('hex'));
      offset += ADDRESS_SIZE;
    }
  }
  
  return { tokens, fees };
};
